// The server's mark rules a live tick must also obey (review N2): a dust print
// says nothing about a price, and a print more than ~50× away from the price
// the row already carries is decode garbage, not a move. One TS definition;
// the Go one is pkg/quotepool (IsDustPrint, MarkPrint) — a shared function
// across the two languages is not possible, so these mirror it, and the
// constants below are copies (no cross-language test). The follow-up that
// removes the copy is a server mark on the WS frame.

import { TETHER_USDT_MASTER } from './searchDefault'
import { isTonQuoteToken } from './tonQuote'

/** dex.GrossSpotRatio (backend pkg/dex/repair_decision.go: e^ln(50) = 50). */
export const GROSS_SPOT_RATIO = 50

/** dex.dustQuoteFloor: 100 000 raw units of the quote. */
const DUST_QUOTE_RAW = 100_000

/**
 * A tick whose QUOTE leg is dust (the candle's test, quotepool.IsDustPrint).
 * WS trade frames carry quote_amount with decimals applied, so the raw floor
 * is read in the quote's own decimals: 0.0001 TON, 0.1 USD₮. A quote whose
 * decimals this side does not know is not judged.
 */
export function isDustQuote(
  quoteAmount: number | undefined,
  quoteToken: string | undefined
): boolean {
  // A frame that states no quote amount cannot be judged (the wire states it).
  if (typeof quoteAmount !== 'number' || !Number.isFinite(quoteAmount)) return false
  if (quoteToken === TETHER_USDT_MASTER) return quoteAmount <= DUST_QUOTE_RAW / 1e6
  if (isTonQuoteToken(quoteToken)) return quoteAmount <= DUST_QUOTE_RAW / 1e9
  return false
}

/** Whether price is more than GROSS_SPOT_RATIO away from ref (either side). */
export function grossDivergent(price: number, ref: number): boolean {
  if (!(price > 0) || !(ref > 0)) return false
  return price > ref * GROSS_SPOT_RATIO || price < ref / GROSS_SPOT_RATIO
}
